module.exports = __webpack_public_path__ + "static/media/COS_HH_BIOSTIME.52c2640b.svg";